export const DURATION = 3e3
